import { useAllocationRule } from "../services/centra/allocation-rule/mm-allocation-rule-provider";
import { useCartWarehouseStock } from "./use-cart-warehouse-stock";

export type DeliveryDataStatus = "loading" | "ready" | "error";

export const useDeliveryDataStatus = (): DeliveryDataStatus => {
  const {
    allocationRule,
    isLoading: isAllocationLoading,
    hasError: allocationHasError,
  } = useAllocationRule();
  const { isLoading: isStockLoading, hasError: stockHasError } =
    useCartWarehouseStock();

  if (isAllocationLoading || isStockLoading) {
    return "loading";
  }

  if (allocationHasError || stockHasError) {
    return "error";
  }

  if (!allocationRule || allocationRule.warehouses.length === 0) {
    return "error";
  }

  return "ready";
};
